import { api } from "../api";
import {
  AssignUserToProject,
  User,
  UserToAssign
} from "../../types/user.types";

export const userService = api.injectEndpoints({
  endpoints: (build) => ({
    getAllUsers: build.query<Array<User>, string>({
      query: () => ({
        url: "/user/all-users"
      })
    }),
    getUsersToAssign: build.query<Array<UserToAssign>, number>({
      query: (projectId) => ({
        url: "/user/users-to-assign",
        params: { projectId }
      })
    }),
    assignUsersToProject: build.mutation<number, Array<AssignUserToProject>>({
      query: (user) => ({
        url: "/user/assign-users-to-project",
        method: "POST",
        body: user
      })
    }),
    createUser: build.mutation<number, User>({
      query: (user) => ({
        url: "/user/user",
        method: "POST",
        body: user
      })
    }),
    updateUser: build.mutation<number, User>({
      query: (user) => ({
        url: "/user/user",
        method: "PUT",
        body: user
      })
    }),
    deleteUser: build.mutation<void, number>({
      query: (userId) => ({
        url: "/user/user",
        method: "DELETE",
        params: { id: userId }
      })
    }),
    updatePassword: build.mutation<void, string>({
      query: (password) => ({
        url: "/user/update-password",
        method: "PUT",
        params: { password }
      })
    }),
  })
});

export const {
  useGetAllUsersQuery,
  useLazyGetUsersToAssignQuery,
  useAssignUsersToProjectMutation,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useUpdatePasswordMutation
} = userService;